import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const Grid3: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--grid', 'svg-icon--grid-3')}
    data-icon={icon}
    viewBox="0 0 20 17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g className={s.gridFill} fillRule="evenodd">
      <path d="M0 0h6v8H0zM7 0h6v8H7zM14 0h6v8h-6zM0 9h6v8H0zM7 9h6v8H7zM14 9h6v8h-6z" />
    </g>
  </svg>
);

export default Grid3;
